export type UpdateMotiveErrorCode = 'PERMISSION_DENIED' | 'MISSING_ARGUMENT' | 'NAME_ALREADY_EXISTS' | 'UNKNOWN';

export class UpdateMotiveError extends Error {
    code: UpdateMotiveErrorCode;

    constructor(code: UpdateMotiveErrorCode, message: string) {
        super(message);
        this.code = code;
    }
}
